import request from '../../axios';
export const postStoryClick = async (guid: string) => {
  const data = await request.post(
    `/api/v2/store/story-post/${guid}/link-count`,
  );
  return data;
};
